import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { InvalidLink } from './features/invalid-link/invalid-link';
import { MeetingEnded } from './features/meeting-ended/meeting-ended';
import { NotAuthorized } from './features/not-authorized/not-authorized';
import { SessionUnavailable } from './features/session-unavailable/session-unavailable';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: InvalidLink,
    data: { pageTitle: 'Invalid Link' },
  },
  {
    path: 'meeting-ended',
    component: MeetingEnded,
    data: { pageTitle: 'Meeting Ended' },
  },
  {
    path: 'session-unavailable',
    component: SessionUnavailable,
    data: { pageTitle: 'Session Unavailable' },
  },
  {
    path: 'not-authorized',
    component: NotAuthorized,
    data: { pageTitle: 'Not Authorized' },
  },
  {
    path: ':id/host',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./features/meeting/meeting.routes').then((m) => m.meetingRoutes),
  },
  {
    path: ':id/guest',
    loadChildren: () =>
      import('./features/join/join.routes').then((m) => m.joinRoutes),
  },
  {
    path: '**',
    component: InvalidLink,
    data: { pageTitle: 'Invalid Link' },
  },
];
